import { forwardRef, useImperativeHandle, useState } from "react"
import { Column } from "ag-grid-community"
import { Tokenizer } from "../../../forms/CSVExportForm/tokenizer"
import AutocompleteInput from "../../autocomplete-input/"
import { openExportTokenDocumentationModal } from "../../modals/actions"
import { useDispatch } from "react-redux"

type tProps = {
    column: Column
    input: HTMLInputElement
    onValueChange?: (value: string) => void
    options?: string[]
    value?: string
}

const TokenizedCellEditor = forwardRef((props: tProps, ref) => {
    const [value, setValue] = useState(props.value || "")
    const dispatch = useDispatch()

    // This is required to have the cell editor pop out of the cell when the contents are too large for the cell
    useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                return value
            },
        }
    })

    return (
        <AutocompleteInput
            value={value}
            onValueChange={setValue}
            onDetailsRequested={option => {
                dispatch(openExportTokenDocumentationModal(option.expression))
            }}
            optionCallback={Tokenizer.getTokenSuggestions}
            allOptions={Tokenizer.getTokenSuggestions()}
        />
    )
})

export default TokenizedCellEditor
